import { useMutation, useQueryClient } from "@tanstack/react-query";
import deleteTaskComment from "../requests/deleteTaskComment";
import { taskCommentsUrl, taskUrl } from "../requests/urls";
import { refetchActivityLogWithDelay } from "../utils/refetchActivityLog";
import { tasksKeyMaker } from "./useGetTasks";
import { tasksKeyMakerV2 } from "./useGetTasks.v2";
import { tasksKeyMakerV3 } from "./useGetTasks.v3";
export default function useRemoveTaskComment(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ taskId, commentId }) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return deleteTaskComment(taskId, commentId, config);
        },
        onMutate: ({ taskId, commentId }) => {
            // NOTE: optimistically update query data
            queryClient.setQueriesData({ queryKey: [taskCommentsUrl(taskId)], exact: false }, (query) => {
                if (query) {
                    return {
                        ...query,
                        values: query.values.filter((comment) => comment.id !== commentId),
                    };
                }
            });
        },
        onSuccess: (_, { taskId }) => {
            // NOTE: invalidate task details query
            queryClient.invalidateQueries({ queryKey: [taskUrl("v1", taskId)] });
            queryClient.invalidateQueries({ queryKey: [taskUrl("v2", taskId)] });
            queryClient.invalidateQueries({ queryKey: [taskUrl("v3", taskId)] });
            // NOTE: invalidate all cached paginated tasks queries
            queryClient.invalidateQueries({ queryKey: tasksKeyMaker(null) });
            queryClient.invalidateQueries({ queryKey: tasksKeyMakerV2(null) });
            queryClient.invalidateQueries({ queryKey: tasksKeyMakerV3(null) });
            // NOTE: refetch activity log
            refetchActivityLogWithDelay(taskId, queryClient);
        },
        onSettled: (_, __, { taskId }) => {
            // NOTE: invalidate all cached paginated task comments queries
            queryClient.invalidateQueries({ queryKey: [taskCommentsUrl(taskId)] });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useRemoveTaskComment.js.map